import React from "react";
import HeroImg from "../../assets/images/yourstylist/Hero.jpg";
import HeroImg2 from "../../assets/images/yourstylist/IMG_2693.jpg";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./styles.css";
const Hero = () => {
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 2000,
  };
  const images = [HeroImg, HeroImg2];
  return (
    <div
      className="w-screen  mx-0 p-0  object-fit object-center px-0 
    "
    >
      <Slider {...settings}>
        {images.map((img, x) => (
          <img
            key={x}
            src={img}
            alt=""
            className="w-screen  p-0 m-0 h-[300px] md:h-[600px] lg:h-screen  transform transition-transform duration-300 hover:scale-110 "
          />
        ))}
      </Slider>
    </div>
  );
};

export default Hero;
